import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export type PropertyTabId =
  | 'property'
  | 'intelligence'
  | 'investment'
  | 'location';

export interface PropertyTab {
  id: PropertyTabId;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-property-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './property-tabs.component.html',
  styleUrls: ['./property-tabs.component.scss'],
})
export class PropertyTabsComponent {
  @Input() activeTab: PropertyTabId = 'property';

  @Output() activeTabChange = new EventEmitter<PropertyTabId>();

  readonly tabs: PropertyTab[] = [
    {
      id: 'property',
      label: 'Property',
      icon: 'building',
    },
    {
      id: 'intelligence',
      label: 'Intelligence',
      icon: 'sparkles',
    },
    {
      id: 'investment',
      label: 'Investment',
      icon: 'chart',
    },
    {
      id: 'location',
      label: 'Location',
      icon: 'location',
    },
  ];

  constructor(private readonly element: ElementRef<HTMLElement>) {}

  selectTab(tab: PropertyTabId): void {
    if (this.activeTab === tab) {
      return;
    }

    const positions: { element: HTMLElement; top: number; left: number }[] = [];
    for (let ancestor = this.element.nativeElement.parentElement; ancestor; ancestor = ancestor.parentElement) {
      if (ancestor.scrollHeight > ancestor.clientHeight) positions.push({ element: ancestor, top: ancestor.scrollTop, left: ancestor.scrollLeft });
    }
    const pageTop = typeof window === 'undefined' ? 0 : window.scrollY;
    const pageLeft = typeof window === 'undefined' ? 0 : window.scrollX;
    this.activeTabChange.emit(tab);
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(() => {
      const content = this.element.nativeElement.parentElement?.querySelector<HTMLElement>('.property-tab-content');
      for (const position of positions) {
        const shortfall = position.top - (position.element.scrollHeight - position.element.clientHeight);
        if (content && shortfall > 0) content.style.minHeight = `${content.offsetHeight + shortfall}px`;
        position.element.scrollTop = position.top;
        position.element.scrollLeft = position.left;
      }
      if (typeof window !== 'undefined') window.scrollTo({ top: pageTop, left: pageLeft, behavior: 'instant' });
    });
  }
}